module.exports = __webpack_public_path__ + "static/media/get_coffee.9b1051b6.gif";